/**-------------------------------  Copyright ---------------------------------
This software has been developed by Orange Labs TGI/OLS/SOFT
Copyright (c) Orange Labs 2018

COPYRIGHT    : This file is the property of Orange Labs.
Copyright Orange Labs 2018, All Rights Reserved

This software is the confidential and proprietary information of Orange Labs.

You shall not disclose such Confidential Information and shall use it only
in accordance with the terms of the license agreement you entered into with
Orange Labs.

AUTHORS      : Orange Labs  TGI/OLS/SOFT
EMAIL        : soft.cybersec@orange.com
-----------------------------------------------------------------------------*/


import YaraService from '@/services/YaraService'
import {RuleSetVO} from '@/valueObjects/RuleSetVO'
import {Component, Vue} from 'vue-property-decorator'
import YaraServiceMixin from '@/services/YaraServiceMixin'
import MessageBox from '@/components/shared/MessageBox'
import {ERROR_MESSAGE_TYPE} from '@/utils/constants'

@Component({
    components: {
      MessageBox,
    },
    mixins: [YaraServiceMixin],
})
export default class YaraRuleSet extends Vue {
    private yaraService: YaraService

    // It is mandatory to declare reactive properties
    // (see: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties)
    private ruleSet: RuleSetVO = new RuleSetVO('', -1, '')
    private message = ''
    private messageType = ERROR_MESSAGE_TYPE

    public mounted() {
        if (this.$route.params.ruleSetId !== undefined) {
            this.loadRuleSet(Number(this.$route.params.ruleSetId))
        }
    }

    public async loadRuleSet(ruleSetId: number): Promise<void> {
        try {
            this.message = ''
            this.ruleSet = await this.yaraService.getRuleSet(ruleSetId)
        } catch (e) {
            this.message = 'Loading of Yara rulesets has failed. ' + e.errorMessage
        }
    }

    public async saveRuleSet(): Promise<void> {
        try {
            this.message = ''
            if (this.ruleSet.name.length === 0) {
                throw new Error('Missing rule set name')
            }
            if (this.ruleSet.text.length < 5) {
                throw new Error('Invalid rule set - The rule is too short to be valid')
            }

            if (this.ruleSet.id === -1) {
                await this.yaraService.saveRuleSet(this.ruleSet)
            } else {
                await this.yaraService.patchRuleSet(this.ruleSet)
            }
            this.$router.push({ name: 'yararulesetlist'})

        } catch (e) {
            if (e.errorStatusCode === 400) {
                this.message = e.errorTitle + ': ' + e.errorDetail
            } else {
                this.message = 'The Yara ruleset has not been saved. ' + e.errorMessage
            }
        }
    }
    private get isDomainSelected(): boolean {
        if (this.ruleSet.applyToAndroguard === false &&
            this.ruleSet.applyToMemoryDump === false &&
            this.ruleSet.applyToNetwork === false &&
            this.ruleSet.applyToSourceCode === false) {
            return false
        }
        return true
    }

    private clearMessage() {
        this.message = ''
    }
}
